import { TextContent } from '@cloudscape-design/components';
import { useApi } from 'src/hooks/useApi';
import { useTranslate } from 'src/i18n/useTranslate';
import { ArticleDetailsApiType, LastModifiedDateType } from 'src/types/useApi';
import { useEffect } from 'react';

type LastModifiedDateProps = {
    artifactId: string;
    contentObjectLcmsXmlGUID: string;
    dateUpdated: string;
};

export const LastModifiedDate = ({
    artifactId,
    contentObjectLcmsXmlGUID,
    dateUpdated,
}: LastModifiedDateProps) => {
    const t = useTranslate();
    const { makeRequest, data, error }: LastModifiedDateType = useApi({
        method: 'GET',
    });

    useEffect(() => {
        if (artifactId && contentObjectLcmsXmlGUID) {
            makeRequest({
                url: `learning-artifacts/lastModifiedDate/${artifactId}/${contentObjectLcmsXmlGUID}`,
            });
        }
    }, []);

    const getDate = () => {
        if (data) {
            return new Date(data).toDateString();
        } else {
            return dateUpdated;
        }
    };
    return (
        <TextContent>
            <small>
                {t('details-page-last-modified', 'Last modified on')}{' '}
                <small data-last-modified-date>{getDate()}</small>
            </small>
        </TextContent>
    );
};
